export default function() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      user: '='
    },
    link: function(scope, element) {
      let status = 'Uninvited';
      let status_color = 'label-warning';

      if (scope.user.invited) {
        status = 'Pending';
        status_color = 'label-success';
      }

      if (scope.user.firstLogin === false) {
        status = 'Active';
        status_color = 'label-primary';
      }

      scope.user.status = status;
      element.html(status);
      element.addClass(status_color);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/userStatus/index.js